import {
  NEW_DATA_LOADING,
  NEW_DATA_SUCCESS,
  NEW_DATA_FAILED,
  NEW_DATA_CLEAR,
  NEW_TEST_DATA_SUCCESS,
  NEW_TEST_DATA_CLEAR,
  SET_BACK_TO_OLD_UI_MESSAGE,
  RESET_BACK_TO_OLD_UI_MESSAGE,
} from '../actionTypeConstants/NewDataNotify';

const initialState = {
  newData: {
    loading: false,
    newDataAvailable: false,
    executing: false,
    error: null,
    testsCount: 0,
  },
  switchToOldUIMsg: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case NEW_DATA_LOADING:
      return {
        ...state,
        new: {
          ...state.newData,
          loading: true,
        },
      };

    case NEW_DATA_SUCCESS:
      return {
        ...state,
        newData: {
          ...state.newData,
          loading: false,
          newDataAvailable: true,
        },
      };

    case NEW_DATA_FAILED:
      return {
        ...state,
        newData: {
          ...state.newData,
          loading: false,
          newDataAvailable: false,
          error: action.error,
        },
      };

    case NEW_DATA_CLEAR:
      return {
        ...state,
        newData: initialState.newData,
      };

    case NEW_TEST_DATA_SUCCESS:
      let count = ++state.newData.testsCount;
      return {
        ...state,
        newData: {
          ...state.newData,
          testsCount: count,
        },
      };
    case NEW_TEST_DATA_CLEAR:
      return {
        ...state,
        newData: {
          ...state.newData,
          testsCount: 0,
        },
      };
    case SET_BACK_TO_OLD_UI_MESSAGE:
      return {
        ...state,
        switchToOldUIMsg: true,
      };
    case RESET_BACK_TO_OLD_UI_MESSAGE:
      return {
        ...state,
        switchToOldUIMsg: false,
      };

    default:
      return state;
  }
}

export const newDataAvailable = () => (dispatch) => {
  dispatch({
    type: NEW_DATA_SUCCESS,
  });
};
export const clearNotifier = () => (dispatch) => {
  dispatch({
    type: NEW_DATA_CLEAR,
  });
};
